import React, {Component} from 'react';

import img1 from "../../imgs/1.jpg";
import img2 from "../../imgs/2.jpg";
import img3 from "../../imgs/3.jpg";

// import {Carousel} from "antd"
import Carousel from "../../components/Carousel";


class Index extends Component {
    render() {
        return (
            <div>

                <Carousel
                    dots={true}
                    delay={5000}
                    afterChange={(currentIndex) => {
                        console.log(`当前显示的是 ${currentIndex}`)
                    }}>

                    <img src={img1}/>
                    <img src={img2}/>
                    <img src={img3}/>

                </Carousel>

            </div>
        )
    }
}

export default Index;


